import React from 'react';
import { Button, Column, Margin, Row } from '@upgrade/react-components';

import Fluid from '../../Fluid';
import { Heading, Text } from '../TypographyPublicSite';
import { Section } from '../styles';
import { toHtmlSanitize } from '../../../utils/remark-html';
import { FeatureContainer, StyledImage } from './styles';

const VerticalFeatures = ({
  verticalFeatures: { backgroundColor, items, title, ctaButtonText, ctaLinkUrl, ctaButtonAriaLabel }
}) => {
  return (
    <Section borderless data-color={backgroundColor} padding="md">
      <Fluid padding={{ xs: ['none', 'none', 'lg'], sm: ['none', 'none', '2xl'] }}>
        <Row xsVerticalAlign="middle" xsHorizontalAlign="center">
          <Column xs={12} lg={10} xsHorizontalAlign="center" smHorizontalAlign="start">
            <Heading as="h4" align="center" marginBottom="xl" size="sm">
              {title}
            </Heading>
            {items.map(({ title: itemTitle, ...itemProps }, idx) => (
              <Feature key={itemTitle} title={itemTitle} reverse={idx % 2 === 1} {...itemProps} />
            ))}
          </Column>
        </Row>
        {ctaButtonText && ctaLinkUrl ? (
          <Margin top="2xl">
            <Row xsHorizontalAlign="center">
              <Column xs={12} sm={4}>
                <Button fullWidth href={ctaLinkUrl} buttonProps={{ 'aria-label': ctaButtonAriaLabel }}>
                  {ctaButtonText}
                </Button>
              </Column>
            </Row>
          </Margin>
        ) : null}
      </Fluid>
    </Section>
  );
};

const Feature = ({ title, description, image, imageAlt, reverse }) => {
  return (
    <FeatureContainer>
      <Row
        xsVerticalAlign="middle"
        xsHorizontalAlign="center"
        smHorizontalAlign="start"
        gutter="large"
        reverse={reverse}
      >
        <Column xs={12} sm={5} xsHorizontalAlign="center" smHorizontalAlign={reverse ? 'end' : 'start'}>
          <StyledImage alt={imageAlt} src={image} />
        </Column>
        <Column xs={12} sm={7}>
          {title ? (
            <Heading as="h5" size="xs" marginBottom="sm">
              {title}
            </Heading>
          ) : null}
          {description ? (
            <Text
              size="md"
              as="p"
              color="contentWeak"
              dangerouslySetInnerHTML={{ __html: toHtmlSanitize(description, { removeWrappingPTag: true }) }}
            />
          ) : null}
        </Column>
      </Row>
    </FeatureContainer>
  );
};

export default VerticalFeatures;
